export class MultiTopSlidingPanelModule {
    constructor() {
        if ($(".container-component__multi-top-sliding-panel").length > 0) {
            this.init();
        }
    }

    init() {

        var that = this;
        var output = that.GenerateMultiTopSlidingPanelTemplate();
        var injected = "";
        $("#multiTopSlidingPanel .slideItem").each(function (index) {

            var dataIcon = $(this).data("iconurl");
            var dataText = $(this).data("text");

            injected += that.GenerateMultiTopSlidingPanelHtml(dataIcon, dataText, index)

        });
        
        $(".js-multi-top-sliding-panel").html(output);

        $(".js-multi-top-sliding-panel").find(".js-top-sliding-panel-carousel-items").html(injected);
        
    }

    GenerateMultiTopSlidingPanelTemplate() {
        return `<div class="container-component__multi-top-sliding-panel container-fluid py-2">
            <div class="row no-gutters align-items-center">

                <div class="col-auto">
                    <a class="h1 control-icon" href="#carouselExampleControls" role="button" data-slide="prev">
                        <i class="fas fa-chevron-left"></i>
                    </a>
                </div>

                <div class="col">
                    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner js-top-sliding-panel-carousel-items">

                        </div>
                    </div>
                </div>

                <div class="col-auto">
                    <a class="h1 control-icon" href="#carouselExampleControls" role="button" data-slide="next">
                        <i class="fas fa-chevron-right"></i>
                    </a>
                </div>
            </div>
        </div>`;

    }

    GenerateMultiTopSlidingPanelHtml(icon, text, index) {
        var active = "";
        if (index == 0) {
            active = "active";
        }

        if (icon == "") {
            return `<div class="carousel-item ${active}">
                <div class="row align-items-center">
                    <div class="col-12 carousel-item-text">
                        ${text}
                    </div>
                </div>
            </div>`;
        }
        else {
            return `<div class="carousel-item ${active}">
                <div class="row align-items-center">
                    <div class="col-3">
                        <img src="${icon}" class="d-block img-fluid" />
                    </div>
                    <div class="col-9 carousel-item-text">
                        ${text}
                    </div>
                </div>
            </div>`;
        }

        
    }

}



